import {
  Component,
  h,
  Element,
  Host, Listen, State, Event, EventEmitter, Method
} from '@stencil/core';

@Component({
  tag: 'envc-meta',
  styleUrl: 'envc-meta.scss',
  scoped: true
})

export class EnvcMeta {
  @Element() host: HTMLElement;

  @Event() openSearchDrawerEvent: EventEmitter<{ state: boolean | null }>
  @Event() openMobileNavEvent: EventEmitter<{ state: boolean | null }>
  @State() toggleState: boolean = false;
  @State() mobileMenuState: boolean = false;

  @State() showCart: boolean = false
  @State() showContact: boolean = false
  @State() showSearch: boolean = false
  @State() showBurgerMenu: boolean = false
  @State() hasEnvironmentNav: boolean = false;

  @State() cartURL: string | null = null
  @State() contactURL: string | null = null

  @State() showLoginBtn: boolean = false
  @State() loginUrl: string = ''
  @State() loginRedirect: boolean = false

  @Event() private isMetaNavEmpty: EventEmitter<boolean>;

  /*
    Handle Search State
    Open/Close Search
  */

  private handleSearchDrawerState(event: MouseEvent) {
    event.preventDefault()

    this.openSearchDrawerEvent.emit({
      state: !this.toggleState
    })
  }


  /**
   * Listeners
   */

  @Listen('openSearchDrawerEvent', { target: 'window' })
  openSearchDrawerEventHandler(event: CustomEvent<{state: boolean | null }>) {
    this.toggleState = event.detail?.state
  }

  @Listen('openMobileNavEvent', { target: 'window' })
  openMobileNavEventHandler(event: CustomEvent<{ state: boolean | null }>) {
    this.mobileMenuState = event.detail?.state ?? false;
  }


  /*
    Handle mobile Menu state
  */

  private handleMobileMenu(e: MouseEvent) {
    e.preventDefault()
    this.mobileMenuState = !this.mobileMenuState
    this.openMobileNavEvent.emit({ state: this.mobileMenuState })
  }


  /*
    Event to show/hide Quick-Navigation Elements
    like login, cart etc.
  */

  @Method()
  async handleShowIcons(
    cartBtn: boolean,
    contactBtn: boolean,
    searchBtn: boolean,
    cartUrl?: string,
    contactUrl?: string,
    showMenu?: boolean
  ) {
    this.showCart = cartBtn
    this.showContact = contactBtn
    this.showSearch = searchBtn
    this.showBurgerMenu = showMenu
    this.cartURL = cartUrl
    this.contactURL = contactUrl
  }


  /*
    Login BTN
    for mobile view
  */

  @Method()
  async handleLoginBtn(showLoginBtn: boolean, loginUrl?: string, loginRedirect?: boolean) {
    this.showLoginBtn = showLoginBtn
    this.loginUrl = loginUrl
    this.loginRedirect = loginRedirect
  }


  /*
    Create and fire Event
    if Component is loaded
  */

  @State() loadEvent = new CustomEvent('metaNavigationDidLoad', { detail: { message: 'true' }})

  componentDidLoad() {
    document.dispatchEvent(this.loadEvent);

    // Prüfen, ob <ul slot="environmentNav"> Elemente enthält
    const ul = this.host.querySelector('ul[slot="environmentNav"]') as HTMLUListElement | null;

    const updateNavState = () => {
      if (ul && ul.childElementCount > 0) {
        this.hasEnvironmentNav = true;
      } else {
        this.isMetaNavEmpty.emit(true);
      }
    };

    updateNavState();

    if (ul) {
      const observer = new MutationObserver(updateNavState);
      observer.observe(ul, { childList: true });
    }
  }

  componentDidUpdate() {
    document.dispatchEvent(this.loadEvent)
  }

  render() {
    return (
      <Host>
        <div class="meta-nav">
          <slot name="environmentNav" />

          <ul class={{
            'meta-nav__quick-navigation': true,
            'meta-nav__quick-navigation--no-border': !this.hasEnvironmentNav
          }}>
            { this.showSearch && (
              <li class={{ search: true, 'is-active': this.toggleState }}>
                <a href="#" onClick={(event) => this.handleSearchDrawerState(event)}>
                  Suche
                </a>
              </li>
            )}

            { this.showContact && (
              <li class={{
                contact: true,
                'is-active': window.location.pathname.includes('/kontakt')
              }}>
                <a href={ this.contactURL || '/kontakt' }>Kontakt</a>
              </li>
            )}

            { this.showCart && (
              <li class={{
                'cart': true,
                'is-active': window.location.pathname.includes('/warenkorb')
              }}><env-minicart-element></env-minicart-element>
              </li>
            )}

            {
              this.showLoginBtn && (
                <li class="login">
                  {this.loginRedirect}
                  {
                    this.showLoginBtn && this.loginRedirect && this.loginUrl ? (
                      // B2B handling
                      <a href={this.loginUrl}>Einloggen</a>
                    ) : (
                      // B2C handling Angular APP
                      <env-oauth-element keycloak-realm={(window as any)?.ENV_APP_REALM} client-id="kko" check-login="true" />
                    )
                  }
                </li>
              )
            }

            { this.showBurgerMenu && (
              <li class="burger-menu">
                <a
                  href="#"
                  class={{ 'is-active': this.mobileMenuState }}
                  onClick={(event) => this.handleMobileMenu(event)}
                >
                  Öffnen des mobilen Menüs
                </a>
              </li>
            )}
          </ul>
        </div>
      </Host>
    );
  }
}
